import { render, staticRenderFns } from "./OsLogo.vue?vue&type=template&id=b7ab59c4&scoped=true&"
import script from "./OsLogo.vue?vue&type=script&lang=js&"
export * from "./OsLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ab59c4",
  null
  
)

export default component.exports